import React  from 'react'
import CreditMemoItem from '../../../Domain/CreditMemo/CreditMemoItem';
import ShowEntityData from '../../../Elements/ShowEntityData';
import CreditMemoService from '../../../Services/CreditMemo/CreditMemoService';


export default class CreditMemoDetailsInfoTab extends React.Component 
{
    static defaultProps={

    };

    constructor(props) 
    {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);

        this.state = {
            creditMemoId:urlParams.get('id'),
            loading:true
        };
    }

    componentDidMount() 
    {
        
    }

    

    render()
    {
        return (
          <ShowEntityData
            itemId={this.state.creditMemoId}
            entityName='Credit Memo Details'
            type={CreditMemoItem}
            serviceGetByIdFunction={CreditMemoService.GetById}
          />
        );
    }
}

